import { MerchantStatusData, RainforestSession } from "../../domain/invoicing/rainforest";
import { useEffect, useRef } from "react";
import useRainforestComponents from "./useRainforestComponents";
import { Skeleton } from "antd";

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "rainforest-merchant-onboarding": any;
    }
  }
}

type RainforestOnboardingComponent = {
  addEventListener: (type: string, listener: (e: any) => void) => void
  removeEventListener: (type: string, listener: (e: any) => void) => void
}

type Props = {
  merchantStatusData: MerchantStatusData
  rainforestSession: RainforestSession
  onSubmitted: () => void
}

const MerchantOnboarding = ({merchantStatusData, rainforestSession, onSubmitted}: Props) => {
  const loadingStatus = useRainforestComponents(rainforestSession)

  if (loadingStatus !== 'READY') {
    return <Skeleton active />
  }

  return <MerchantOnboardingInternal
    merchantStatusData={merchantStatusData}
    rainforestSession={rainforestSession}
    onSubmitted={onSubmitted}
  />
}

const MerchantOnboardingInternal = ({merchantStatusData, rainforestSession, onSubmitted}: Props) => {
  const ref = useRef<RainforestOnboardingComponent>(null);
  
  useEffect(() => {
    if (ref.current) {
      const handleSubmitted = () => {
        onSubmitted()
      }

      const element = ref.current

      element.addEventListener('submitted', handleSubmitted)

      return () => {
        element.removeEventListener('submitted', handleSubmitted)
      }
    }
  }, [])

  return <rainforest-merchant-onboarding
    ref={ref}
    session-key={rainforestSession.sessionKey}
    merchant-id={merchantStatusData.merchantId}
    merchant-application-id={merchantStatusData.applicationId}
    terms-and-conditions-url='https://synkedup.com/terms-conditions/'
    style-button-color="#FF5C35"
  ></rainforest-merchant-onboarding>
}

export default MerchantOnboarding